import React from 'react';
import { Search, X } from 'lucide-react';

const ProductFilters = ({ filters, onFilterChange }) => {
  const statusOptions = [
    { value: 'all', label: 'Todos' },
    { value: 'active', label: 'Activo' },
    { value: 'inactive', label: 'Desactivado' }
  ];

  return (
    <div className="bg-[#1A1A1A] rounded-xl border border-white/8 p-5 space-y-5 font-oranienbaum shadow-sm">
      <h2 className="text-base font-bold font-oranienbaum text-[#D6EF4E]">Filtros</h2>
      <div className="space-y-4">
        {/* Search */}
        <div>
          <label className="block text-xs font-oranienbaum text-white/50 mb-2">
            Buscar por Nombre
          </label>
          <div className="relative">
            <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-white/30 w-4 h-4" />
            <input
              type="text"
              placeholder="Buscar producto..."
              value={filters?.search}
              onChange={(e) => onFilterChange('search', e?.target?.value)}
              className="w-full pl-9 pr-3 py-2 bg-[#111111] border border-white/10 rounded-lg text-white text-sm font-oranienbaum placeholder-white/25 focus:outline-none focus:border-[#D6EF4E]/50 transition-colors"
            />
          </div>
        </div>

        {/* Status */}
        <div>
          <label className="block text-xs font-oranienbaum text-white/50 mb-2">
            Estado
          </label>
          <select
            value={filters?.status}
            onChange={(e) => onFilterChange('status', e?.target?.value)}
            className="w-full px-3 py-2 bg-[#111111] border border-white/10 rounded-lg text-white text-sm font-oranienbaum focus:outline-none focus:border-[#D6EF4E]/50 transition-colors appearance-none cursor-pointer"
          >
            {statusOptions?.map((opt) => (
              <option key={opt?.value} value={opt?.value} className="bg-[#1A1A1A]">
                {opt?.label}
              </option>
            ))}
          </select>
        </div>
      </div>
      {/* Clear */}
      <div className="pt-3 border-t border-white/8">
        <button
          onClick={() => onFilterChange('reset')}
          className="w-full flex items-center justify-center gap-2 px-3 py-2 bg-white/5 border border-white/10 rounded-lg text-white/60 text-sm font-oranienbaum hover:bg-white/10 hover:text-white transition-colors"
        >
          <X className="w-4 h-4" />
          Limpiar Filtros
        </button>
      </div>
    </div>
  );
};

export default ProductFilters;